import { ArrayValue, RecordValue, Schema, StringValue } from '@coveo/bueno';
import { nonEmptyString, requiredNonEmptyString, } from '../../utils/validate-payload.js';
import { engineConfigurationDefinitions, getSampleEngineConfiguration, } from '../engine-configuration.js';
export const searchEngineConfigurationSchema = new Schema({
    ...engineConfigurationDefinitions,
    search: new RecordValue({
        options: {
            required: false,
        },
        values: {
            pipeline: new StringValue({ required: false, emptyAllowed: true }),
            searchHub: nonEmptyString,
            locale: nonEmptyString,
            timezone: nonEmptyString,
            authenticationProviders: new ArrayValue({
                required: false,
                each: requiredNonEmptyString,
            }),
            proxyBaseUrl: new StringValue({ required: false, url: true }),
        },
    }),
});
/**
 * Creates a sample search engine configuration.
 *
 * @returns The sample search engine configuration.
 */
export function getSampleSearchEngineConfiguration() {
    return {
        ...getSampleEngineConfiguration(),
        search: {
            searchHub: 'default',
        },
    };
}
